<!-- This File shows the Parent details for a Seller -->
<template>
  <div class="">
      <!-- Parent -->

      <br />
      <v-card>
       <v-card-title primary-title>
           <div style="text-align:left">
             You can remove {{kid.name}} from your account. Once this is done you will no longer be able to access their account.
             This does not cancel their account subscription, if you want to cancel their account login to their account and cancel
             their subscription there.
           </div>

       </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="removeKid" :loading="inprogress" flat color="accent">
           Remove {{kid.name}}
          </v-btn>
       </v-card-actions>

       <div class="success--text" v-if="success">
         {{ kid.name }} was removed from your account successfully.
       </div>
       <div class="error--text" v-if="errMessage">
         {{ errMessage }}
       </div>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import config from '../../config.js'

export default {
  name: 'RemoveKidCard',
  components: {
  },
  props: {
    kid: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState({
    })

  },

  data () {
    return {
      showRemoveKid: false,
      inprogress: false,
      errMessage: null,
      success: false
    }
  },
  methods: {
    removeKid: function () {
      // Ask for confirm
      this.$confirm(`Are you sure you want to remove ${this.kid.name} from your account?`).then(async res => {
        if (res) {
          // Remove the kid
          this.errMessage = null
          this.success = false
          this.inprogress = true

          // Call the async function to reset flag
          try {
            const removeKidFromParent = config.getFunctions().httpsCallable('removeKidFromParent')
            console.log('DEBUG: rkfp: ' + JSON.stringify(this.kid))
            await removeKidFromParent({kid: this.kid})

            this.success = true

            // Go back to the parent's main page and select none
            this.$router.push({name: 'ParentPortal'})
            this.$store.commit('parent/setKidSelected', null)
          } catch (err) {
            console.error('ERROR removing kid: ' + JSON.stringify(err))
            this.errMessage = 'Error removing kid: ' + err
          }
          this.inprogress = false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
